import * as React from 'react';
import { Box, Button, Dialog, DialogContent, DialogTitle, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import Header from '../components/header';
import { deleteKey, getKeys, upsertKey } from '../utilities/api-utils';
import { IKey } from '../models/key';
import { setIsSearching } from '../store/reducers/cabinetSlice';
import { useAppDispatch } from '../store';

function KeysView() {
  const [inputKey, setInputKey] = useState<string>('');
  const [parentKey, setParentKey] = useState<string>('');
  const [keys, setKeys] = useState<Array<IKey>>([]);
  const [selectedKey, setSelectedKey] = useState<IKey | undefined>();
  const [newKeyName, setNewKeyName] = useState<string>('');
  const [createDialog, setCreateDialog] = useState<boolean>(false);
  const [deleteDialog, setDeleteDialog] = useState<boolean>(false);

  const dispatch = useAppDispatch();
  dispatch(setIsSearching(false));

  const onSubmit = () => {
    getChildKeys(inputKey);
  };

  const getChildKeys = async (key: string) => {
    setKeys([]);
    if (key) {
      await getKeys(key).then((resp) => {
        setParentKey(key);
        setKeys(resp.data);
      }).catch((err) => {
        setKeys([]);
        setParentKey('');
        alert(err);
      });
    }
  };

  const createKey = async () => {
    if (newKeyName) {
      const payload = {
        reference: newKeyName
      };
      const resp = await upsertKey(parentKey, payload);

      if (resp?.status !== 201 && resp?.status !== 200) {
        let detailString = '';
        Object.keys(resp.response.data.details).forEach(k => {
          detailString += resp.response.data.details[k];
        });
        alert(`${resp.response.data.error}:\n${detailString}`);
      } else {
        if (resp.data.key) {
          const alertMessage = `SAVE THIS KEY. IT WILL NOT BE DISPLAYED AGAIN\nChild key: ${resp.data.key}`;
          alert(alertMessage);
        }
        getChildKeys(parentKey);
        setCreateDialog(false);
      }
    }
  };

  const deleteChildKey = async (key?: IKey) => {
    if (key && key.parent_id !== null) {
      await deleteKey(parentKey, key.id).then((_resp) => {
        alert(`${key.reference} has been deleted!`);
      }).catch((err) => {
        alert(err);
      });
      getChildKeys(parentKey);
      setDeleteDialog(false);
      setSelectedKey(undefined);
    }
  };

  return (
    <div>
      <Header title='Keys' />
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'start', alignItems: 'center', minHeight: '690px'}}> 
        <div
          style={{
            height: '150px',
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'space-around',
            alignItems: 'center',
          }}>
          <Typography variant='h5'>Enter Admin or Parent Organization Key</Typography>
          <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '300px'}}>
            <TextField value={inputKey} type='password' onChange={(e) => setInputKey(e.target.value)} />
            <Button variant='contained' onClick={() => {
              onSubmit();
              setInputKey('');
            }}>Submit</Button>
          </div>
        </div>
        <TableContainer component={Paper} sx={{maxHeight: '480px'}}>
          <Table
            sx={{minWidth: '600px'}}>
            <TableHead>
              <TableRow>
                <TableCell align='left'>Id</TableCell>
                <TableCell align='left'>Parent Id</TableCell>
                <TableCell align='left'>Name</TableCell>
                <TableCell align='left'>Created At</TableCell>
                <TableCell align='center'>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {keys.map((x, index) => (
                  <TableRow key={index}>
                  {Object.entries(x).map(([key,value]) => (
                    <TableCell key={key}>{value}</TableCell>
                  ))}
                    <TableCell align='center' sx={{padding: '0'}}>
                      <Button variant='contained' disabled={x.parent_id === null} onClick={() => {
                          setSelectedKey(x);
                          setDeleteDialog(true);
                        }}>Delete</Button>
                    </TableCell>
                  </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Button variant='contained' sx={{marginTop: 'auto', fontSize: '20px', width: 'auto'}} onClick={() => {
          setCreateDialog(true);
          setNewKeyName('');
          }}>Create Child Key</Button>
      </div>
      <Dialog
        sx={{
          width: '100%'
        }}
        fullWidth
        maxWidth='md'
        open={createDialog}
        onClose={() => setCreateDialog(false)}>
        <DialogTitle>
          <div style={{
            fontWeight: '500',
            color: '#121F35',
            fontSize: '40px'
          }}>Create Child Key</div>
        </DialogTitle>
        <DialogContent sx={{height: '400px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
          <Box sx={{height: '240px',display: 'flex', flexDirection: 'column', justifyContent: 'start', alignItems: 'center'}}>
            <Typography variant='h5'>Enter Key Name</Typography>
            <TextField inputProps={{ maxLength: 36 }} sx={{marginTop: '20px', marginBottom: '20px'}} value={newKeyName} onChange={(e) => setNewKeyName(e.target.value)}/>
            <Button variant='contained' sx={{fontSize: '20px'}} onClick={() => createKey()}>Create</Button>
          </Box>
        </DialogContent>
      </Dialog>
      <Dialog
        sx={{
          width: '100%'
        }}
        fullWidth
        maxWidth='md'
        open={deleteDialog}
        onClose={() => setDeleteDialog(false)}>
        <DialogTitle>
          <div style={{
            fontWeight: '500',
            color: '#121F35',
            fontSize: '40px'
          }}>Delete {selectedKey?.reference} Child Key</div>
        </DialogTitle>
        <DialogContent sx={{height: '400px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
          <Box sx={{height: '240px',display: 'flex', flexDirection: 'column', justifyContent: 'start', alignItems: 'center'}}>
            <Typography variant='h5'>Are you sure you want to delete this key?</Typography>
            <Button variant='contained' sx={{fontSize: '20px'}} onClick={() => deleteChildKey(selectedKey)}>Delete</Button>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default KeysView;
